import { render, staticRenderFns } from "./rizhi.vue?vue&type=template&id=1e7feb78&scoped=true&"
import script from "./rizhi.vue?vue&type=script&lang=js&"
export * from "./rizhi.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=1e7feb78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7feb78",
  null
  
)

export default component.exports